module.exports = __webpack_public_path__ + "band_4.51fec5be.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_4.png
// module id = lPoN
// module chunks = 0